export class ReportIncidents {
    id: number;
    code: string;
    reasonName: string;
    incidentsContent: string;
    isCompleted: boolean;
    isCompensation: boolean;
    compensationValue: number;
    incidentsByEmpName: string;
    handleEmpName: string;
    createdByEmpName: string;
    createdWhen: any; 
    totalCount: any;
}